import { render, staticRenderFns } from "./thirdparties-list.vue?vue&type=template&id=b024a746&scoped=true&"
import script from "./thirdparties-list.vue?vue&type=script&lang=js&"
export * from "./thirdparties-list.vue?vue&type=script&lang=js&"
import style0 from "./thirdparties-list.vue?vue&type=style&index=0&id=b024a746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b024a746",
  null
  
)

export default component.exports